import { useContext, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";
import "bootstrap/dist/css/bootstrap.min.css";
import "./css/style.scss";

import LogInWrapper from "./pages/logInWrapper.jsx";
import NewRegistration from "./pages/NewRegistration.jsx";

import Dashboard from "./pages/Dashboard.jsx";
import RecordingPledge from "./pages/RecordingOfPledges.jsx";
import AppContext from "./context/AppContext";
import UpdateScore from "./pages/UpdateIccScore.jsx";
import LiveRanking from "./pages/LiveRanking.jsx";
import BlogsAndArticles from "./pages/blogs.jsx";
import BlogDetails from "./pages/blogDetails.jsx";
import MyProfile from "./pages/myProfile.jsx";
import Forum from "./pages/forum.jsx";
import ForumDetails from "./pages/forumDetails.jsx";
import ProtectedRoute from "./protected-route/ProtectedRoute.js";
import VideosSection from "./pages/videos.jsx";
import AudioSection from "./pages/audio.jsx";
import ViewTransactions from "./pages/viewTransactions.jsx";
import NotificationDetails from "./components/my-profile/notificationDetails.jsx";
import Resources from "./pages/resources.jsx";
import ContactUs from "./pages/contactUs.jsx";
import Quotes from "./pages/quotes.jsx";
import ConditionalGoogleTranslate from "./components/common/ConditionalGoogleTranslate.jsx";
import TemplesStats from "./pages/TemplesStats.jsx";
import Unsubscribe from "./pages/unsubscribe.jsx";
import ChantingForm from "./pages/chantingForm.jsx";
import BslsRegistration from "./pages/BslsRegistration.jsx";
import ChantingRecords from "./pages/chantingTable.jsx";
import RathYatraRegister from "./pages/rathYatra.jsx";
import AppShell from "./components/layout/AppShell.jsx";
import TspTeamsPage from "./modules/tsp/pages/teams/TspTeamsPage.jsx";
import TspBusLeadersDirectoryPage from "./modules/tsp/pages/teams/TspBusLeadersDirectoryPage.jsx";
import TspLiveRankingPage from "./modules/tsp/pages/live-ranking/TspLiveRankingPage.jsx";
import TspLiveTrackingPage from "./modules/tsp/pages/live-tracking/TspLiveTrackingPage.jsx";
import TspBlogsPage from "./modules/tsp/pages/blogs/TspBlogsPage.jsx";
import TspDashboardPage from "./modules/tsp/pages/dashboard/TspDashboardPage.jsx";
import TspJourneysPage from "./modules/tsp/pages/journeys/TspJourneysPage.jsx";
import TspJourneyListPage from "./modules/tsp/pages/journeys/TspJourneyListPage.jsx";
import TspAddJourneyPage from "./modules/tsp/pages/journeys/TspAddJourneyPage.jsx";
import TspEditJourneyPage from "./modules/tsp/pages/journeys/TspEditJourneyPage.jsx";
import TspJourneyDetailPage from "./modules/tsp/pages/journeys/TspJourneyDetailPage.jsx";
import TspJourneyLiveLocationPage from "./modules/tsp/pages/journeys/tracking/TspJourneyLiveLocationPage.jsx";
import TspStatsPage from "./modules/tsp/pages/stats/TspStatsPage.jsx";
import TspContactsPage from "./modules/tsp/pages/contacts/TspContactsPage.jsx";
import TspReportsPage from "./modules/tsp/pages/reports/TspReportsPage.jsx";
import TspMediaGalleryPage from "./modules/tsp/pages/media-gallery/TspMediaGalleryPage.jsx";
import TspStoriesPage from "./modules/tsp/pages/stories/TspStoriesPage.jsx";
import TspForumPage from "./modules/tsp/pages/forum/TspForumPage.jsx";
import TspRoutePlanningPage from "./modules/tsp/pages/route-planning/TspRoutePlanningPage.jsx";
import TspCityVisitsPage from "./modules/tsp/pages/city-visits/TspCityVisitsPage.jsx";
import TspLocationsPage from "./modules/tsp/pages/locations/TspLocationsPage.jsx";
import TspAccommodationPage from "./modules/tsp/pages/accommodation/TspAccommodationPage.jsx";
import TspPrasadamPage from "./modules/tsp/pages/prasadam/TspPrasadamPage.jsx";
import TspDailyReportsPage from "./modules/tsp/pages/daily-reports/TspDailyReportsPage.jsx";
import TspBookDistributionPage from "./modules/tsp/pages/book-distribution/TspBookDistributionPage.jsx";
import TspAddBookDistributionPage from "./modules/tsp/pages/book-distribution/TspAddBookDistributionPage.jsx";
import TspPublicResponsePage from "./modules/tsp/pages/public-response/TspPublicResponsePage.jsx";
import TspAdviceRepositoryPage from "./modules/tsp/pages/advice-repository/TspAdviceRepositoryPage.jsx";
import TspAdviceDetailPage from "./modules/tsp/pages/advice-repository/TspAdviceDetailPage.jsx";
import TspAdviceFormPage from "./modules/tsp/pages/advice-repository/TspAdviceFormPage.jsx";
import TspKnowledgeCityPage from "./modules/tsp/pages/knowledge-repository/TspKnowledgeCityPage.jsx";
import TspNotificationsPage from "./modules/tsp/pages/notifications/TspNotificationsPage.jsx";
import TspSearchPage from "./modules/tsp/pages/search/TspSearchPage.jsx";
import TspLayout from "./modules/tsp/layouts/TspLayout.jsx";
import TspProtectedRoute from "./modules/tsp/components/common/TspProtectedRoute.jsx";
import TSP_PERMISSIONS from "./modules/tsp/constants/tspPermissions";


export default function App() {
  const { user } = useContext(AppContext);
  let parentTemple = false;

  return (
    <HelmetProvider>
      <Router>
        <AppShell user={user}>
          <Routes>
            {user != null && <Route exact path="/login" element={<ProtectedRoute children={<LogInWrapper />} />} />}
            <Route exact path="/login" element={<LogInWrapper />}></Route>
            <Route exact path="/new-registration" element={<NewRegistration />}></Route>
            <Route exact path="/rath-yatra" element={<RathYatraRegister />}></Route>
            {/* <Route exact path="/narsimha-mantra-japa-report" element={<ChantingForm />}></Route>
            <Route exact path="/chanting-records" element={<ChantingRecords />}></Route> */}
            <Route path="/unsubscribe/:id" element={<Unsubscribe />} />
            <Route path="/" element={<ProtectedRoute children={<Dashboard />} />} />
            <Route path="/update-score" element={<ProtectedRoute children={<UpdateScore />} />} />

            {/* <Route path="/bsls-registration" element={<ProtectedRoute children={<BslsRegistration />} />} /> */}

            <Route path="/temple-stats" element={<ProtectedRoute children={<TemplesStats />} />} />
            <Route exact path="/recording-pledge" element={<ProtectedRoute children={<RecordingPledge />} />} />
            <Route exact path="/live-ranking" element={<ProtectedRoute children={<LiveRanking />} />} />
            <Route exact path="/blogs" element={<ProtectedRoute children={<BlogsAndArticles />} />} />
            <Route exact path="/blogs/:id" element={<ProtectedRoute children={<BlogsAndArticles />} />} />
            <Route exact path="/blog-details/:id" element={<ProtectedRoute children={<BlogDetails />} />} />
            <Route path="/my-profile" element={<ProtectedRoute children={<MyProfile />} />} />
            <Route exact path="/forum" element={<ProtectedRoute children={<Forum />} />} />
            <Route exact path="/forum-details/:id" element={<ProtectedRoute children={<ForumDetails />} />} />
            <Route exact path="/videos" element={<ProtectedRoute children={<VideosSection />} />} />
            <Route exact path="/audios" element={<ProtectedRoute children={<AudioSection />} />} />
            <Route exact path="/view-history" element={<ProtectedRoute children={<ViewTransactions />} />} />
            <Route exact path="/notification-details/:id" element={<ProtectedRoute children={<NotificationDetails />} />} />
            <Route exact path="/posters" element={<ProtectedRoute children={<Resources />} />} />
            <Route exact path="/contact-us" element={<ProtectedRoute children={<ContactUs />} />} />
            <Route exact path="/quotes" element={<ProtectedRoute children={<Quotes />} />} />
            <Route
              exact
              path="/tsp/teams"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.TEAMS_VIEW}
                  children={
                    <TspLayout>
                      <TspBusLeadersDirectoryPage />
                    </TspLayout>
                  }
                />
              }
            />
            {/* Team management (create teams, assign leaders and members) — the
                original /tsp/teams screen, now reached from the directory. */}
            <Route
              exact
              path="/tsp/teams/manage"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.TEAMS_VIEW}
                  children={
                    <TspLayout>
                      <TspTeamsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.DASHBOARD_VIEW}
                  children={
                    <TspLayout>
                      <TspDashboardPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/journeys"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.JOURNEYS_VIEW}
                  children={
                    <TspLayout>
                      <TspJourneysPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/journey-list"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.JOURNEYS_VIEW}
                  children={
                    <TspLayout>
                      <TspJourneyListPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/journeys/new"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.JOURNEYS_MANAGE}
                  children={
                    <TspLayout>
                      <TspAddJourneyPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/journeys/:journeyId/edit"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.JOURNEYS_MANAGE}
                  children={
                    <TspLayout>
                      <TspEditJourneyPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/journeys/:journeyId"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.JOURNEYS_VIEW}
                  children={
                    <TspLayout>
                      <TspJourneyDetailPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/journeys/:journeyId/live"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.JOURNEYS_VIEW}
                  children={
                    <TspLayout>
                      <TspJourneyLiveLocationPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/stats"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.REPORTS_VIEW}
                  children={
                    <TspLayout>
                      <TspStatsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/stats/:journeyId"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.REPORTS_VIEW}
                  children={
                    <TspLayout>
                      <TspStatsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/route-planning"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.ROUTE_PLANNING_VIEW}
                  children={
                    <TspLayout>
                      <TspRoutePlanningPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/city-visits"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.CITY_VISITS_VIEW}
                  children={
                    <TspLayout>
                      <TspCityVisitsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/locations"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.LOCATIONS_VIEW}
                  children={
                    <TspLayout>
                      <TspLocationsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/accommodation"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.ACCOMMODATION_VIEW}
                  children={
                    <TspLayout>
                      <TspAccommodationPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/prasadam"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.PRASADAM_VIEW}
                  children={
                    <TspLayout>
                      <TspPrasadamPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/daily-reports"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.DAILY_REPORTS_VIEW}
                  children={
                    <TspLayout>
                      <TspDailyReportsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/book-distribution"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.BOOK_DISTRIBUTION_VIEW}
                  children={
                    <TspLayout>
                      <TspBookDistributionPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/book-distribution/new"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.BOOK_DISTRIBUTION_MANAGE}
                  children={
                    <TspLayout>
                      <TspAddBookDistributionPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/public-response"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.PUBLIC_RESPONSE_VIEW}
                  children={
                    <TspLayout>
                      <TspPublicResponsePage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/advice"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.ADVICE_VIEW}
                  children={
                    <TspLayout>
                      <TspAdviceRepositoryPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/advice/new"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.ADVICE_MANAGE}
                  children={
                    <TspLayout>
                      <TspAdviceFormPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/advice/:adviceId"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.ADVICE_VIEW}
                  children={
                    <TspLayout>
                      <TspAdviceDetailPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/advice/:adviceId/edit"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.ADVICE_MANAGE}
                  children={
                    <TspLayout>
                      <TspAdviceFormPage />
                    </TspLayout>
                  }
                />
              }
            />
            {/* Legacy path from the earlier scaffold — kept only as a redirect so old links/bookmarks still work. */}
            <Route exact path="/tsp/advice-repository" element={<Navigate to="/tsp/advice" replace />} />
            {/* The Knowledge Repository list was removed: a city's summary opens from its journey ("View Summary"). */}
            <Route exact path="/tsp/knowledge" element={<Navigate to="/tsp" replace />} />
            <Route
              exact
              path="/tsp/knowledge/:cityId"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.KNOWLEDGE_REPOSITORY_VIEW}
                  children={
                    <TspLayout>
                      <TspKnowledgeCityPage />
                    </TspLayout>
                  }
                />
              }
            />
            {/* Legacy path from the earlier scaffold — redirect only. */}
            <Route exact path="/tsp/knowledge-repository" element={<Navigate to="/tsp" replace />} />
            <Route
              exact
              path="/tsp/notifications"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.NOTIFICATIONS_VIEW}
                  children={
                    <TspLayout>
                      <TspNotificationsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/search"
              element={
                <TspProtectedRoute
                  permission={null}
                  children={
                    <TspLayout>
                      <TspSearchPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/contacts"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.CONTACTS_VIEW}
                  children={
                    <TspLayout>
                      <TspContactsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/reports"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.REPORTS_VIEW}
                  children={
                    <TspLayout>
                      <TspReportsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/media-gallery"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.MEDIA_VIEW}
                  children={
                    <TspLayout>
                      <TspMediaGalleryPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/success-stories"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.STORIES_VIEW}
                  children={
                    <TspLayout>
                      <TspStoriesPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route exact path="/tsp/stories" element={<Navigate to="/tsp/success-stories" replace />} />
            {/* TSP's own Live Ranking (team leaderboard) and Blogs. The ICC
                platform's /live-ranking and /blogs pages are unchanged. */}
            <Route
              exact
              path="/tsp/live-ranking"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.REPORTS_VIEW}
                  children={
                    <TspLayout>
                      <TspLiveRankingPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/live-tracking"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.DASHBOARD_VIEW}
                  children={
                    <TspLayout>
                      <TspLiveTrackingPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/blogs"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.STORIES_VIEW}
                  children={
                    <TspLayout>
                      <TspBlogsPage />
                    </TspLayout>
                  }
                />
              }
            />
            <Route
              exact
              path="/tsp/forum"
              element={
                <TspProtectedRoute
                  permission={TSP_PERMISSIONS.FORUM_VIEW}
                  children={
                    <TspLayout>
                      <TspForumPage />
                    </TspLayout>
                  }
                />
              }
            />
          </Routes>
        </AppShell>
      </Router>
    </HelmetProvider>
  );
}
